<p>image-loading-panel works!</p>
